<template>
    <main class="login">
        <hk-background></hk-background>
        <div class="login-container">
            <div class="login-container-tab flex flex-vertical-center">
                <h2
                    :class="[{ active: mode === 'normal' }, 'login-container-tab-text']"
                    @click="changeWay('normal')"
                >
                    密码登录
                </h2>
                <h2
                    :class="[{ active: mode === 'phone' }, 'login-container-tab-text']"
                    @click="changeWay('phone')"
                >
                    手机号登录
                </h2>
                <h2
                    v-if="!isProd"
                    :class="[{ active: mode === 'qrcode' }, 'login-container-tab-text']"
                    @click="changeWay('qrcode')"
                >
                    二维码登录
                </h2>
            </div>
            <div class="login-container-content">
                <div v-if="mode === 'phone'" class="phone-way">
                    <input
                        v-model="phone"
                        type="text"
                        maxlength="11"
                        class="phone"
                        placeholder="请输入手机号"
                    />
                    <div class="msg-code">
                        <input
                            v-model="code"
                            type="text"
                            class="code-input"
                            placeholder="请输入验证码"
                        />
                        <input
                            type="button"
                            :disabled="codeBtnState"
                            :value="codeText"
                            class="get-code"
                            @click="debounceSendSms"
                        />
                    </div>
                </div>
                <div v-if="mode === 'normal'" class="password-way">
                    <input v-model="phone" maxlength="18" type="text" placeholder="请输入账号" />
                    <input v-model="password" type="password" placeholder="请输入密码" />
                    <p class="flex flex-end">
                        <router-link to="/forget" class="forget-password">忘记密码？</router-link>
                    </p>
                </div>
                <div v-if="mode === 'qrcode' && !isProd" class="qrcode-container flex flex-center">
                    <div
                        v-loading.lock="loading"
                        class="qrcode"
                        element-loading-text="加载中"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                    >
                        <vue-qrcode v-if="schema" :margin="0" :width="150" :value="schema" />
                        <div
                            v-if="unvalid"
                            class="qrcode-unvalid flex flex-column flex-center flex-vertical-center"
                            @click="refreshQRcode"
                        >
                            <i class="qrcode-icon el-icon-circle-close"></i>
                            <p class="text-center">二维码已失效</p>
                        </div>
                    </div>
                </div>
            </div>
            <hk-button
                :text="mode !== 'qrcode' ? '登录' : '云校用户扫码登录'"
                :customStyle="buttonStyle"
                :height="50"
                @handleClick="handleLogin"
            ></hk-button>
            <p class="attention-text flex flex-end">
                没有账号？<router-link :to="{ name: 'Register' }" class="to-register"
                    >立即注册</router-link
                >
            </p>
        </div>

        <HkDialogCaptcha
            :state.sync="captchaDlgVisible"
            title=""
            buttonText="确定"
            @close="closeCaptchaDialog"
            @confirm="onCaptchaConfirm"
        >
            <template #content>
                <div class="captcha">
                    <p>验证码：<input v-model="captcha" maxlength="10" type="text" /></p>
                    <p class="hint">输入下图中的字符，不区分大小写</p>
                    <div class="image">
                        <img :src="captchaUrl" alt="" />
                        <input type="button" value="看不清，换一张" @click="getCaptchaInfo" />
                    </div>
                </div>
            </template>
        </HkDialogCaptcha>
    </main>
</template>

<script>
import HkBackground from '@components/HkBackground';
import HkButton from '@components/HkButton';
import { isEmpty, isPhone } from '@helpers/validation';
import { sendSms, captchaInfo } from '@api/common';
import { mapActions } from 'vuex';
import { debounce } from 'lodash';
import VueQrcode from 'vue-qrcode';
import { getQrcode, getQrcodeState } from '@api/auth';
import { SET_TOKEN } from '@constants/store';
import { LOGINED, LOGIN_STATUS } from '@constants/common';
import Cookies from 'js-cookie';
import HkDialogCaptcha from '@components/HkDialogCaptcha';

export default {
    components: {
        HkBackground,
        HkButton,
        VueQrcode,
        HkDialogCaptcha
    },
    data() {
        return {
            isProd: process.env.NODE_ENV === 'production' && process.env.VUE_APP_MODE !== 'test',
            isPhone: false,
            mode: 'normal',
            phone: '',
            code: '',
            password: '',
            codeText: '发送验证码',
            buttonStyle: {
                width: '100%',
                color: '#fff',
                shadowColor: '#D695DE',
                background: true,
                startColor: '#89009A',
                endColor: '#A60AAC'
            },
            codeBtnState: false,
            timer: '',
            time: 60,
            debounceSendSms: null,
            schema: '',
            QRCodetimer: null,
            loading: true,
            unvalid: false,

            captchaDlgVisible: false, // 验证码对话框是否可见
            captcha: '', // 图形验证码
            captchaSessionId: '',
            captchaUrl: '' // 图形验证码URL
        };
    },
    computed: {
        redirectUrl() {
            const redirectUrl = this.$route.query.redirectUrl || {
                name: 'Home'
            };
            return redirectUrl;
        }
    },
    created() {
        this.debounceSendSms = debounce(this.sendCode, 250, {
            leading: true,
            trailing: false
        });
        this.loading = true;
    },
    beforeDestroy() {
        this.clearTimer();
    },
    methods: {
        ...mapActions(['login', 'loginByCode']),
        changeWay(way) {
            this.mode = way;
            if (way === 'qrcode') {
                this.refreshQRcode();
            } else {
                this.clearQRCodeTimer();
            }
        },
        async sendCode() {
            if (this.validatePhone()) {
                this.getCaptchaInfo();
            }
        },
        clearTimer() {
            clearInterval(this.timer);
            this.timer = null;
            this.codeText = '发送验证码';
            this.codeBtnState = false;
            this.time = 60;
        },
        validatePhone() {
            if (isPhone(this.phone)) {
                return true;
            }

            this.$message.error('请输入正确的手机号');
            return false;
        },
        validateForm() {
            const { phone: cellphone, password, code: validationCode, mode } = this;
            if (!cellphone) {
                this.$message.error('请输入账号');
                return false;
            }
            if (mode === 'phone') {
                if (isEmpty(validationCode)) {
                    this.$message.error('请输入验证码');
                    return false;
                }
            } else {
                if (isEmpty(password)) {
                    this.$message.error('请输入密码');
                    return false;
                }
            }
            return true;
        },
        async handleLogin() {
            if (this.mode === 'qrcode') {
                return;
            }
            const { phone: cellphone, password, code: validationCode, mode } = this;
            if (!this.validateForm()) {
                return false;
            }
            if (mode === 'phone') {
                await this.loginByCode({ cellphone, validationCode });
            } else {
                await this.login({ cellphone, password });
            }
            await this.$store.dispatch('queryUserInfo');
            this.$message.success('登录成功');
            this.$router.replace(this.redirectUrl);
            this.$trackEvent('登录', mode === 'phone' ? '手机号登录' : '密码登录');
        },
        refreshQRcode() {
            this.loading = true;
            this.unvalid = false;
            this.queryQRcode().finally(() => {
                this.loading = false;
            });
        },
        async queryQRcode() {
            this.clearQRCodeTimer();
            const { data } = await getQrcode();
            const { uuid, schema } = data;
            this.schema = schema;
            this.openCheckQRCode(uuid);
        },
        openCheckQRCode(uuid) {
            setTimeout(() => {
                this.unvalid = true;
                this.clearQRCodeTimer();
            }, 3 * 60 * 1000);
            this.QRCodetimer = setInterval(() => {
                this.openCheckQRCodeState(uuid);
            }, 2000);
            this.$once('hook:beforeDestroy', this.clearQRCodeTimer);
        },
        async openCheckQRCodeState(uuid) {
            const { access_token, code } = await getQrcodeState(uuid);
            if (code !== 0) {
                this.unvalid = true;
                this.clearQRCodeTimer();
            }
            if (access_token) {
                this.$store.commit(SET_TOKEN, access_token);
                Cookies.set(LOGIN_STATUS, LOGINED);
                this.clearQRCodeTimer();
                await this.$store.dispatch('queryUserInfo');
                this.$message.success('登录成功');
                this.$router.replace(this.redirectUrl);
                this.$trackEvent('登录', '二维码登录');
            }
        },
        clearQRCodeTimer() {
            if (this.QRCodetimer) {
                clearInterval(this.QRCodetimer);
                this.QRCodetimer = null;
            }
        },
        // 获取验证码信息
        async getCaptchaInfo() {
            try {
                const resp = await captchaInfo();
                this.captchaUrl = resp.data.captcha_url;
                this.captchaSessionId = resp.data.session_id;

                this.captchaDlgVisible = true;
            } catch {
                this.$message.error('获取验证码失败');
            }
        },
        // 关闭验证码对话框
        closeCaptchaDialog() {
            this.captchaDlgVisible = false;
        },
        // 验证码对话框确定事件处理
        async onCaptchaConfirm() {
            this.captcha = this.captcha.trim();
            if (!this.captcha) {
                this.$message.error('请输入图形验证码');
                return;
            }

            this.captchaDlgVisible = false;

            this.codeBtnState = true;

            try {
                await sendSms(this.phone, this.captcha, this.captchaSessionId, 3);
                this.codeText = `${this.time}s`;
                this.timer = setInterval(() => {
                    if (this.time > 0) {
                        this.time--;
                        this.codeText = `${this.time}s`;
                    } else {
                        this.clearTimer();
                    }
                }, 1000);
            } catch {
                this.codeBtnState = false;
                this.captcha = '';
            }
        }
    }
};
</script>
<style lang="scss" scoped>
/* @import url(); 引入css类 */
.login {
    width: 100%;
    min-width: 1200px;
    height: 100vh;
    min-height: 800px;
    margin: 0 auto;
    position: relative;
    .login-container {
        box-sizing: border-box;
        width: 482px;
        height: 534px;
        background: #fff;
        box-shadow: -3px 2px 32px 0px #eaeaea;
        position: absolute;
        top: 200px;
        right: 336px;
        z-index: 99;
        padding: 82px 50px 0;
        .login-container-tab {
            padding-bottom: 9px;
            border-bottom: 1px solid #ededed;
            margin-bottom: 38px;
            &-text {
                font-size: 24px;
                font-family: PingFang SC;
                font-weight: bold;
                color: #868685;
                padding-bottom: 18px;
                cursor: pointer;
                user-select: none;
                &:not(:last-of-type) {
                    margin-right: 20px;
                }
            }
            .active {
                color: #312e33;
                background: url('~@images/base/login-way-check.png') no-repeat center bottom;
                cursor: default;
            }
        }
        .login-container-content {
            width: 100%;
            .phone-way {
                input[type='text'] {
                    box-sizing: border-box;
                    width: 100%;
                    height: 46px;
                    background: #f4f4f4;
                    border: none;
                    outline: none;
                    margin-bottom: 26px;
                    color: #a0a0a0;
                    font-size: 14px;
                    padding: 0 20px;
                }
                .msg-code {
                    position: relative;
                    .get-code {
                        position: absolute;
                        right: 20px;
                        top: 0;
                        border: none;
                        outline: none;
                        width: 70px;
                        height: 46px;
                        font-size: 14px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #cccbcb;
                        padding: 0;
                        cursor: pointer;
                        background: #f4f4f4;
                    }
                    .code-input {
                        padding: 0 110px 0 20px;
                    }
                }
            }
            .password-way {
                input {
                    box-sizing: border-box;
                    width: 100%;
                    height: 46px;
                    background: #f4f4f4;
                    border: none;
                    outline: none;
                    margin-bottom: 26px;
                    color: #a0a0a0;
                    font-size: 14px;
                    padding: 0 20px;
                }
                p {
                    margin-bottom: 26px;
                    .forget-password {
                        text-decoration: none;
                        font-size: 16px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #868685;
                        display: block;
                        width: 80px;
                    }
                }
            }
        }
        .attention-text {
            margin-top: 28px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #30332e;
            .to-register {
                color: #7d0f83;
                text-decoration: none;
            }
        }
        .qrcode {
            position: relative;
            width: 150px;
            height: 150px;
            background: #f4f4f4;
            margin-bottom: 20px;
        }
        .qrcode-unvalid {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.8);
            color: #ffffff;
        }
        .qrcode-icon {
            font-size: 36px;
            padding-bottom: 8px;
        }
    }

    .captcha {
        & > p {
            font-size: 16px;

            & > input {
                box-sizing: border-box;
                height: 46px;
                background: #f4f4f4;
                border: none;
                outline: none;
                color: #a0a0a0;
                font-size: 16px;
                padding: 0 20px;
            }
        }

        .hint {
            color: #7b7d7c;
            margin-left: 46px;
            margin-top: 4px;
            font-size: 14px;
        }

        .image {
            margin: 10px 0 20px 90px;

            & > img {
                max-width: 150px;
                max-height: 40px;
            }

            & > input {
                color: #729c9b;
                outline: none;
                border: 0;
                background: transparent;
                cursor: pointer;
            }
        }
    }
}
</style>
